export const { phone1 , phone2, email, website, address } = {
  phone1: "+91 75060 59237",
  phone2: "+91 990 245 9001",
  email: "sales@megatradeinc.in",
  website: "www.megatradeinc.in",
  address:
    "Mega Trade Inc. 84/1, 3rd Cross, 2nd Main, Sampangi Rama Nagar, Bangalore – 560027",
};
